<template>
  <div class="FilterBannerRepair">
    <div class="FilterBannerRepair__content">
      <p class="FilterBannerRepair__title">
        <span class="FilterBannerRepair__highlight"><mark data-text="Broken it?">Broken it?</mark></span>
        <span>We Repair It</span>
      </p>
      <p class="FilterBannerRepair__subtitle">
        Lifetime Guarantee
      </p>
      <VisionButton
        class="FilterBannerRepair__btn"
        button-text="Learn More"
        background-colour="white"
        :outline="true"
        size="x-small"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script setup>
const { $track } = useNuxtApp()

const modalStore = useModalStore()

function openModal(slug) {
  modalStore.OPEN_MODAL_PAGE({ slug })
}

async function handleClick() {
  openModal('guaranteed-for-life')

  await $track.global.linkClicked({
    interactionElement: 'guaranteed-for-life',
    interactionSection: 'Filter results',
    interactionCategory: 'Filter banner'
  }, 'Clicked Inline Filter Banner')
}
</script>

<style lang="postcss">
.FilterBannerRepair {
  @apply bg-off-black p-4 w-full flex flex-col items-start;

  @screen md {
    @apply p-10
  }
}

.FilterBannerRepair__content {
  @apply mt-[20%];
}

.FilterBannerRepair__title {
  @apply text-base font-bold text-white;

  @screen xs {
    @apply text-lg;
  }

  @screen md {
    @apply heading-1;
  }
}

.FilterBannerRepair__highlight {
  @apply block heading-3;

  @screen md {
    @apply heading-2;
  }

  mark {
    @apply relative
      text-white;
    background: none;
    color: rgba(255, 255, 255, 0);

    &::before {
      @apply absolute block;
      content: attr(data-text);
      top: 0;
      left: 0;
      clip-path: polygon(0 0, 100% 0, 100% 40%, 0 63%);
      background-image: linear-gradient(265.2deg, #858585 60%, #ffffff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &::after {
      @apply absolute block;
      content: attr(data-text);
      top: 0;
      left: -0.04em;
      clip-path: polygon(0 63%, 100% 40%, 100% 90%, 0 90%);
      background-image: linear-gradient(131.78deg, #818181 30%, #ffffff 75%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.FilterBannerRepair__subtitle {
  @apply text-sm font-light text-grey-light mt-2;

  @screen sm {
    @apply text-base;
  }
}

.FilterBannerRepair__btn {
  @apply mt-5;
}
</style>